import { render } from "./CustomOptionContent.vue?vue&type=template&id=f3930030"
import script from "./CustomOptionContent.vue?vue&type=script&lang=ts"
export * from "./CustomOptionContent.vue?vue&type=script&lang=ts"
script.render = render

export default script